import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { AttachmentDownloader } from "../attachmentFileDownloader";
import { CreatePaymentRequestViewModel } from "../createPaymentRequest/createPaymentRequest-viewModel";
import { processStateEnumProvider, processTypeEnumProvider, TransactionTransferTypeEnumProvider } from "../processStateEnumProvider";
import  { PaymentRequestsListView } from "./paymentRequestsList-view"
import { CompiledClass } from "src/formBuilder/datamodel/classGenerator";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class PaymentRequestsListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'درخواست های پرداخت';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.paymentRequests = ObservableArray.create<singlePaymentRequest>();
        this.stateEnumProvider = new processStateEnumProvider();
        this.typeEnumProvider = new processTypeEnumProvider();
        this.transactionTypeEnumProvider = new TransactionTransferTypeEnumProvider();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PaymentRequestsListView();
    }
    public getTypeId(): string {
        return "VM-62C55214-870C-403A-948F-443FEF1D5D53"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set paymentRequests(v: ObservableArray<singlePaymentRequest>) { this._paymentRequests = v; } public get paymentRequests(): ObservableArray<singlePaymentRequest> { return this._paymentRequests;} private _paymentRequests: ObservableArray<singlePaymentRequest>;
    public set stateEnumProvider(v: processStateEnumProvider) { this._stateEnumProvider = v; } public get stateEnumProvider(): processStateEnumProvider { return this._stateEnumProvider;} private _stateEnumProvider: processStateEnumProvider;
    public set typeEnumProvider(v: processTypeEnumProvider) { this._typeEnumProvider = v; } public get typeEnumProvider(): processTypeEnumProvider { return this._typeEnumProvider;} private _typeEnumProvider: processTypeEnumProvider;
    public set transactionTypeEnumProvider(v: TransactionTransferTypeEnumProvider) { this._transactionTypeEnumProvider = v; } public get transactionTypeEnumProvider(): TransactionTransferTypeEnumProvider { return this._transactionTypeEnumProvider;} private _transactionTypeEnumProvider: TransactionTransferTypeEnumProvider;
    

    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PaymentProcessServices/GetAllPaymentProcesses',{
                FurtherQueryInfo:filteringInformation
            });
            this.paymentRequests.update(...result.Requests.map((x,i)=>{
                let r = new singlePaymentRequest(this);
                r.index = i+1;
                r.requestId = x.RequestId;
                r.starter = x.StarterId;
                r.isInvoice = x.IsInvoice;
                r.orderId = x.OrderId;
                r.licenseId = x.LicenseId;
                r.processId = x.ProcessId;
                r.requestCode = x.RequestNo;
                r.orderCode = x.OrderNo;
                r.licenseCode = x.LicenseNo;
                r.transactionCode = x.TransactionCode;
                r.accountingTransaction1Code = x.AccountingTransaction1Code;
                r.accountingTransaction2Code = x.AccountingTransaction2Code;
                r.amount = x.Amount;
                r.requestComment = x.RequestComment;
                r.orderComment = x.OrderComment;
                r.licenseComment = x.LicenseComment;
                r.requestType = x.RequestType;
                r.status = x.Status;
                r.forPerson = x.PersonName;
                r.forPersonId = x.PersonId;
                r.transactionType = x.TransactionTransferType;
                r.requestCreationTime =x.RequestCreationTime==null ? null : moment.utc(x.RequestCreationTime);
                r.orderCreationTime =x.OrderCreationTime==null ? null : moment.utc(x.OrderCreationTime);
                r.licenseCreationTime =x.LicenseCreationTime==null ? null : moment.utc(x.LicenseCreationTime);
                r.canDelete = r.status == 1 && r.starter == null;
                r.requestAttachments.update(...x.RequestAttachments.map(q=>{
                    let r2 = new attachment(r);
                    r2.id = q.Id;
                    r2.name = q.Name;
                    return r2;
                }));
                r.orderAttachments.update(...x.OrderAttachments.map(q=>{
                    let r2 = new attachment(r);
                    r2.id = q.Id;
                    r2.name = q.Name;
                    return r2;
                }));
                r.licenseAttachments.update(...x.LicenseAttachments.map(q=>{
                    let r2 = new attachment(r);
                    r2.id = q.Id;
                    r2.name = q.Name;
                    return r2;
                }));

                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async createNewRequest() {
        let createNewVm = new CreatePaymentRequestViewModel(this);
        let result = await this.requestShowingPopup(createNewVm);
        if(result=='yes'){
            this.loader.refresh();
        }
    }
    
	async print(paymentRequest: singlePaymentRequest):Promise<void>{
        let compiledClass = new CompiledClass(this);
        let starter = paymentRequest.starter;
        if (stringIsNullOrEmpty(paymentRequest.starter)) {
            let paymentInfo = { PaymentInfo: ''};
            if (!stringIsNullOrEmpty(paymentRequest.forPersonId)) {
                paymentInfo = await ServerConnection.callServer('/Complex/PaymentProcessServices/GetPersonPaymentInfo',{
                    PersonId:paymentRequest.forPersonId
                });
            }
            let data = {
                ReqDate:compiledClass.__ConvertToPersianDate(paymentRequest.requestCreationTime, 'YYYY/MM/DD'),
                ReqNo:paymentRequest.requestCode ?? "",
                Party:paymentRequest.forPerson ?? "",
                PayableAmount:paymentRequest.amount ?? 0,
                Description:paymentRequest.requestComment ?? "",
                HesabNo: paymentInfo.PaymentInfo
            };
            new CompiledClass(this).__PrintReport('ca3b8fd2-33b6-4d8f-87f1-737fbb1dea67', data, 1);
        } else if (paymentRequest.isInvoice){
            let invoice = await ServerConnection.callServer('/Complex/PurchaseServices/GetPurchaseFactorDetail',{
                Id:starter
            });
            let contractor = await ServerConnection.callServer("/Complex/BpmsServices/GetFlowInstances", {
                FurtherQueryInfo: { "PaginationInfo": { "PageNo": 1, "PageSize": 3000 }, "OrderInfo": [], "Filters": {"FilterString":"[]","FullSearchString":invoice.SellerId } },
                ProcessId: "356E9A3B-0DFA-41D8-A71C-6CAB9E0E8285",
                AllData: false,
                SelectedColumns: [
                    { "FieldName": "PaymentInfo", "FieldPath": "PaymentInfo" },
                ]
            });
            let data = {
                ReqDate:compiledClass.__ConvertToPersianDate(paymentRequest.requestCreationTime, 'YYYY/MM/DD'),
                ReqNo:paymentRequest.requestCode ?? "",
                factorNo:invoice.FactorNo ?? "",
                FactorDate:compiledClass.__ConvertToPersianDate(invoice.Time, 'YYYY/MM/DD'),
                Supplier:paymentRequest.forPerson ?? "",
                Amount:paymentRequest.amount ?? 0,
                HesabNo:contractor.Rows[0].PaymentInfo ?? "",
                ProjectName:""
            };
            new CompiledClass(this).__PrintReport('547a3768-b495-4b6e-9022-09cccd7e4674', data, 1);
        } else {
            let statusForm = await ServerConnection.callServer("/Complex/BpmsServices/GetSingleInstance", {
                ProcessId: "CDD257B8-F267-4462-9CC1-54A669CB23D4",
                InstanceId: starter,
                AllData: true                
            });
            statusForm = statusForm.Instance;
            let contract = await ServerConnection.callServer("/Complex/BpmsServices/GetSingleInstance", {
                ProcessId: "717C7A98-E470-4520-A458-EB3845E6A62E",
                InstanceId: statusForm.ContractId,
                AllData: true
            });
            contract = contract.Instance;
            let contractor = await ServerConnection.callServer("/Complex/BpmsServices/GetSingleInstance", {
                ProcessId: "1EC6FD1D-BC9A-4160-8281-FB160CDD380B",
                InstanceId: contract.ContractorId,
                AllData: true
            });
            let remaindAmounts;
            let resultTotals = await ServerConnection.callServer("/Complex/BpmsServices/ExecuteSql",{
                Sql : `SELECT SUM(r.Amount) total  FROM flows.StatusForm_StatusForm i 
                JOIN eai.PaymentProcess pp ON i._FlowId_ = pp.StarterId 
                JOIN arap.PaymentRequest r ON r.Id = pp.RequestId WHERE pp.LicenseId IS NOT NULL AND i.ContractId = '${statusForm.ContractId}'
                GROUP BY i.ContractId`
            });
            if (resultTotals.Result.length == 0 || resultTotals.Result[0].length == 0)
                remaindAmounts = null;
            else 
                remaindAmounts = Number.parseInt(resultTotals.Result[0][0]);
            let data = {
                ReqDate:compiledClass.__ConvertToPersianDate(paymentRequest.requestCreationTime, 'YYYY/MM/DD'),
                StatusDate:compiledClass.__ConvertToPersianDate(statusForm.StatusDate, 'YYYY/MM/DD'),
                ContractDate:compiledClass.__ConvertToPersianDate(contract.StartDate, 'YYYY/MM/DD'),
                ReqNo:paymentRequest.requestCode ?? "",
                ContractNo:contract.ContractNo ?? "",
                StatusNo:statusForm.StatusNo ?? 0,
                TotalDiscountPrice:statusForm.Items.reduce((i,q) => q.TotalDiscountPrice + i, 0) ?? 0,
                TotalPrice:statusForm.Items.reduce((i,q) => q.TotalPrice + i, 0) ?? 0,
                Contractor:statusForm.ContractorName ?? "",
                TotalPayedAmount:remaindAmounts ?? 0,
                PayableAmount:paymentRequest.amount ?? 0,
                ProjectName:statusForm.ProjectName ?? "",
                HesabNo:contractor.Instance.PaymentInfo ?? "",
                ContractTitle : statusForm.ContractTitle ?? ""
            };
            new CompiledClass(this).__PrintReport('79d0eb7c-e136-4cad-a633-d8ad17784803', data, 1);
            
        }
	}
      
    async delete(id:any){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PaymentProcessServices/DeleteRequest',{
                ProcessId:id
            });
            if (result.IsSuccessful == false) {
                if (result.Faults[0].Parameters.FaultId == "932D7019-02EC-4033-BB0A-B44EC93A2F90") {
                    await this.messageBoxConfirmWarning("امکان حذف این درخواست پرداخت وجود ندارد.","عملیات ناموفق")
                } else if (result.Faults[0].Parameters.FaultId == "7704C1E5-24C1-4F36-BB5D-18F73CAC1497") {
                    await this.messageBoxConfirmWarning("امکان حذف درخواست پرداختی که دستور پرداخت دارد وجود ندارد.","عملیات ناموفق")
                } else
                    throw new Error("failed");
            } else 
                await this.messageBoxConfirmSuccess('درخواست پرداخت پاک شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}


export class singlePaymentRequest extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PaymentRequestsListViewModel) {
        super(parent);
        
        this.requestAttachments = ObservableArray.create<attachment>();
        this.orderAttachments = ObservableArray.create<attachment>();
        this.licenseAttachments = ObservableArray.create<attachment>();
        this.showDetail = false;
        this._typedParent = parent;
    }
    private _typedParent : PaymentRequestsListViewModel;
   
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    
    public set requestId(v: string) { this._requestId = v; } public get requestId(): string { return this._requestId;} private _requestId: string;
    public set orderId(v: string) { this._orderId = v; } public get orderId(): string { return this._orderId;} private _orderId: string;
    public set licenseId(v: string) { this._licenseId = v; } public get licenseId(): string { return this._licenseId;} private _licenseId: string;
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId;} private _processId: string;
    
    public set requestCode(v: string) { this._requestCode = v; } public get requestCode(): string { return this._requestCode;} private _requestCode: string;
    public set orderCode(v: string) { this._orderCode = v; } public get orderCode(): string { return this._orderCode;} private _orderCode: string;
    public set licenseCode(v: string) { this._licenseCode = v; } public get licenseCode(): string { return this._licenseCode;} private _licenseCode: string;
    public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode;} private _transactionCode: string;
    public set accountingTransaction1Code(v: string) { this._accountingTransaction1Code = v; } public get accountingTransaction1Code(): string { return this._accountingTransaction1Code;} private _accountingTransaction1Code: string;
    public set accountingTransaction2Code(v: string) { this._accountingTransaction2Code = v; } public get accountingTransaction2Code(): string { return this._accountingTransaction2Code;} private _accountingTransaction2Code: string;

    
    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set requestComment(v: string) { this._requestComment = v; } public get requestComment(): string { return this._requestComment;} private _requestComment: string;
    public set orderComment(v: string) { this._orderComment = v; } public get orderComment(): string { return this._orderComment;} private _orderComment: string;
    public set licenseComment(v: string) { this._licenseComment = v; } public get licenseComment(): string { return this._licenseComment;} private _licenseComment: string;
    
    public set requestCreationTime(v: moment.Moment) { this._requestCreationTime = v; } public get requestCreationTime(): moment.Moment { return this._requestCreationTime;} private _requestCreationTime: moment.Moment;
    public set orderCreationTime(v: moment.Moment) { this._orderCreationTime = v; } public get orderCreationTime(): moment.Moment { return this._orderCreationTime;} private _orderCreationTime: moment.Moment;
    public set licenseCreationTime(v: moment.Moment) { this._licenseCreationTime = v; } public get licenseCreationTime(): moment.Moment { return this._licenseCreationTime;} private _licenseCreationTime: moment.Moment;
    
    public set forPerson(v: string) { this._forPerson = v; } public get forPerson(): string { return this._forPerson;} private _forPerson: string;
    public set forPersonId(v: string) { this._forPersonId = v; } public get forPersonId(): string { return this._forPersonId;} private _forPersonId: string;
    public set requestType(v: number) { this._requestType = getAsNumber(v); } public get requestType(): number { return this._requestType;} private _requestType: number;
    public set status(v: number) { this._status = getAsNumber(v); } public get status(): number { return this._status;} private _status: number;
    public set starter(v: string) { this._starter = v; } public get starter(): string { return this._starter;} private _starter: string;
    public set isInvoice(v: boolean) { this._isInvoice = v; } public get isInvoice(): boolean { return this._isInvoice;} private _isInvoice: boolean;
    public set canDelete(v: boolean) { this._canDelete = v; } public get canDelete(): boolean { return this._canDelete;} private _canDelete: boolean;
    
    public set requestAttachments(v: ObservableArray<attachment>) { this._requestAttachments = v; } public get requestAttachments(): ObservableArray<attachment> { return this._requestAttachments;} private _requestAttachments: ObservableArray<attachment>;
    public set orderAttachments(v: ObservableArray<attachment>) { this._orderAttachments = v; } public get orderAttachments(): ObservableArray<attachment> { return this._orderAttachments;} private _orderAttachments: ObservableArray<attachment>;
    public set licenseAttachments(v: ObservableArray<attachment>) { this._licenseAttachments = v; } public get licenseAttachments(): ObservableArray<attachment> { return this._licenseAttachments;} private _licenseAttachments: ObservableArray<attachment>;
    
    public set transactionType(v: number) { this._transactionType = v; } public get transactionType(): number { return this._transactionType;} private _transactionType: number;
    public set showDetail(v: boolean) { this._showDetail = v; } public get showDetail(): boolean { return this._showDetail;} private _showDetail: boolean;
    
    toggleDetail(){
        this.showDetail = !this.showDetail;
    }
    
    async deletePaymentRequest(){
        if(this.canDelete) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','پاک کردن درخواست پرداخت');
            if(result=='yes'){
                this._typedParent.delete(this.processId);
            }
        }
    }

    async print() {
        this._typedParent.print(this);
    }
}

export class attachment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.downloader = new AttachmentDownloader();
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set downloader(v: AttachmentDownloader) { this._downloader = v; } public get downloader(): AttachmentDownloader { return this._downloader;} private _downloader: AttachmentDownloader;
    
}